export interface IImage {
  id?: number;
  url?: string | null;
  type?: string | null;
}

export const defaultValue: Readonly<IImage> = {};
